document.addEventListener('DOMContentLoaded', function() {
  console.log('Script cargado');
  
  function observeElements() {
    const elements = document.querySelectorAll('.card, [data-product-id], .product-recommendations *, .search-results *');
    console.log('Elementos encontrados:', elements.length);
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('visible')) {
          entry.target.classList.add('visible');
          console.log('Clase visible agregada a:', entry.target.className);
        }
      });
    }, {
      threshold: 0.1
    });

    elements.forEach(element => {
      observer.observe(element);
    });
  }
  
  // Ejecutar inmediatamente
  observeElements();
  
  // Ejecutar después de 2 segundos para elementos dinámicos
  setTimeout(observeElements, 2000);
  
  // Observar cambios en el DOM
  const domObserver = new MutationObserver(function() {
    setTimeout(observeElements, 500);
  });
  
  domObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Contador del carrito - versión final
function updateCartCounter() {
  let totalQuantity = 0;
  const cartItems = document.querySelectorAll('.cart-item .quantity__input');
  
  cartItems.forEach(input => {
    totalQuantity += parseInt(input.value) || 0;
  });
  
  const heading = document.querySelector('.drawer__heading');
  if (heading) {
    heading.setAttribute('data-cart-count', totalQuantity.toString());
  }
}

// Ejecutar cuando se carga y cada segundo
document.addEventListener('DOMContentLoaded', updateCartCounter);
setInterval(updateCartCounter, 1000);

// También ejecutar cuando hay cambios en el DOM
const observer = new MutationObserver(updateCartCounter);
observer.observe(document.body, { childList: true, subtree: true });

// Versión más rápida
function autoRemoveZeroItems() {
  const quantityInputs = document.querySelectorAll('.cart-item .quantity__input');
  
  quantityInputs.forEach(input => {
    const quantity = parseInt(input.value) || 0;
    
    if (quantity === 0 && document.activeElement !== input) {
      const cartItem = input.closest('.cart-item');
      
      if (!cartItem.dataset.removing) {
        cartItem.dataset.removing = 'true';
        
        const removeButton = cartItem.querySelector(
          '.cart-remove, ' +
          '[data-cart-remove], ' +
          '.remove-item, ' +
          'button[aria-label*="Remove"], ' +
          'button[aria-label*="Eliminar"], ' +
          '.cart-item__remove, ' +
          'a[href*="remove"]'
        );
        
        if (removeButton) {
          setTimeout(() => {
            removeButton.click();
          }, 100); // Más rápido - solo 100ms
        }
      }
    }
  });
  
  updateCartCounter();
}

// Ejecutar cada 100ms para que sea casi instantáneo
let lastCheck = '';
setInterval(() => {
  const currentState = Array.from(document.querySelectorAll('.cart-item .quantity__input')).map(input => input.value).join(',');
  
  if (currentState !== lastCheck) {
    autoRemoveZeroItems();
    lastCheck = currentState;
  }
}, 100); // Cada 100ms - muy rápido

// Actualizar botón de pago
function updatePayButton() {
  const button = document.querySelector('.cart__ctas button, .cart__ctas .btn');
  const priceElement = document.querySelector('.totals__total-value, .cart-drawer__footer .price');
  
  if (button && priceElement) {
    const price = priceElement.textContent.trim();
    if (!button.textContent.includes('Pagar -')) {
      button.textContent = `Pagar - ${price}`;
    }
  }
}

// Ejecutar cada vez que se actualiza el carrito
setInterval(updatePayButton, 500);

